const initialState = {
  data: [],
  success: false,
  error: false,
};

export const programSave = () => (state = initialState, action) => {
  switch (action.type) {
    case `PROGRAM_SAVE_REQUEST`: {
      return initialState;
    }
    case `PROGRAM_SAVE_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `PROGRAM_SAVE_FAILURE`: {
      return { ...state, data: action.error, success: false, error: true };
    }
    default:
      return state;
  }
};
